module.exports = __webpack_public_path__ + "img/waves-7.a6082d7e.webp";